import styled from 'styled-components';

/** ON 은 보라 채움, OFF 는 회색 — 색만이 아니라 명도로도 갈리게 */
const ON_BG = '#7950f2';
const OFF_BG = '#eef0f3';
const OVERRIDE_BG = '#fff0db';
const OVERRIDE_TEXT = '#8a4600';

export const FeatureFlagStyle = styled.div`
  .flag-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 28px;
    padding: 12px 24px;
    border-bottom: 1px solid #edf0f4;
    background: #fbfcfd;
    font-size: 12px;
    color: var(--settings-muted);
  }
  .flag-legend-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .ant-table-wrapper .ant-table-thead > tr > th {
    background: #f7f8fa;
    font-weight: 600;
    font-size: 13px;
    border-bottom: 1px solid #e4e8ef;
    padding: 11px 12px;
  }
  .ant-table-wrapper .ant-table-thead > tr > th::before {
    display: none;
  }
  .ant-table-wrapper .ant-table-tbody > tr > td {
    padding: 14px 12px;
    border-bottom: 1px solid #f0f2f5;
    font-size: 13px;
  }
  /* 덮어쓴 줄 — 기본값과 다르게 돌고 있다는 표시 */
  .ant-table-wrapper .ant-table-tbody > tr.flag-row-overridden > td {
    background: #fffaf2;
  }

  .flag-ticket {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
    font-weight: 600;
  }
  .flag-app {
    font-size: 11px;
    font-weight: 400;
    padding: 0 6px;
    border: 1px solid #d9dde3;
    border-radius: 3px;
    color: #4b5666;
  }
  .flag-description {
    margin-top: 4px;
    color: #4b5666;
    line-height: 1.5;
  }
  .flag-memo {
    display: inline-flex;
    gap: 6px;
    margin-top: 6px;
    padding: 4px 8px;
    border-radius: 4px;
    background: #f6f7fa;
    font-size: 12px;
    color: #4b5666;
  }
  .flag-memo b {
    font-weight: 600;
  }
  .flag-locked .flag-description,
  .flag-locked-text {
    color: #6b7585;
  }

  .flag-status {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
  }
  .flag-status.is-IN_DEVELOPMENT {
    background: #eef0f3;
    color: #4b5666;
  }
  .flag-status.is-READY_FOR_QA {
    background: #e7f1ff;
    color: #1c5fb8;
  }
  .flag-status.is-READY_FOR_RELEASE {
    background: #e6f6ec;
    color: #1f7a3d;
  }

  .flag-override {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 3px;
    background: ${OVERRIDE_BG};
    color: ${OVERRIDE_TEXT};
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
  }

  .flag-unknown {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    padding: 14px 24px;
    font-size: 13px;
  }
  .flag-unknown + .flag-unknown {
    border-top: 1px solid #f0f2f5;
  }
  .flag-unknown-key {
    font-weight: 600;
    font-family: ui-monospace, Menlo, monospace;
  }
  .flag-unknown-meta {
    flex: 1;
    min-width: 200px;
    color: var(--settings-muted);
  }
`;

/** 맨 위 환경 안내 — 배지와 문구를 한 줄에 */
export const EnvironmentNoticeStyle = styled.div`
  .flag-env-message {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    font-weight: 600;
  }
`;

export const OnOffPill = styled.span<{ $enabled: boolean }>`
  display: inline-block;
  min-width: 44px;
  padding: 3px 0;
  border-radius: 12px;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  background: ${({ $enabled }) => ($enabled ? ON_BG : OFF_BG)};
  color: ${({ $enabled }) => ($enabled ? '#fff' : '#4b5666')};
`;

export const EnvironmentTag = styled.span<{ $production: boolean }>`
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  background: ${({ $production }) => ($production ? '#c92a2a' : '#e7f1ff')};
  color: ${({ $production }) => ($production ? '#fff' : '#1c5fb8')};
`;

export const SwitchModalStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  .flag-summary {
    display: grid;
    grid-template-columns: 72px minmax(0, 1fr);
    gap: 4px 12px;
    padding: 12px 16px;
    border-radius: 6px;
    background: #f6f7fa;
    font-size: 13px;
    line-height: 1.6;
  }
  .flag-summary dt {
    color: var(--settings-muted, #626e7f);
  }
  .flag-summary dd {
    margin: 0;
  }
  .flag-switch-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 14px 16px;
    border: 1px solid #e4e8ef;
    border-radius: 6px;
  }
  .flag-switch-row strong {
    display: block;
    font-size: 14px;
  }
  .flag-field-label {
    display: block;
    margin-bottom: 6px;
    font-size: 13px;
    font-weight: 600;
  }
  .flag-field-hint {
    margin-top: 6px;
    font-size: 12px;
    color: #626e7f;
  }
`;
